export default __webpack_public_path__ + "img/caikuma_confused.a3053508.webp";